module.exports = __webpack_public_path__ + "static/img/1996_phase_function_Paper_Points.48cd0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1996_phase_function_Paper_Points.png
// module id = F0C0
// module chunks = 0